import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { TagService } from '../../services';
import { setHistoryAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_HISTORY),
    switchMap(action =>
      TagService.getHistory(
        action.id,
        action.startDate,
        action.endDate,
        store
      ).pipe(
        map(data => setHistoryAction(action.id, data)),
        catchError(retryAuthentication(action$, 'epics/tags/getHistory'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/getHistory.js